// extracted by mini-css-extract-plugin
export default {"section":"FAQ_section__71N9q","faq":"FAQ_faq__ldcAu","title":"FAQ_title__q8Os4"};